import Breadcrumb from "../../../components/Breadcrumb";
import {
  MergedTicketIcon,
  TicketsDetailIcon,
  TicketsGrayIcon,
} from "../../../icons";
import "../style.scss";
import TagComp from "../../../components/tag";
import { Dropdown, Image, message } from "antd";
// import attachmentImage from "../../../../public/images/attachments/image.png";
// import attachmentImage02 from "../../../../public/images/attachments/image-02.png";
// import attachmentImage03 from "../../../../public/images/attachments/image-03.png";
import { useNavigate } from "react-router";
import { useCallTypes } from "../../../hooks/useCallTypes";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import React, { useEffect, useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import ChangeStatusModal from "../../../components/ModalLayout/components/ChangeStatusModal";
import ConfirmModal from "../../../components/ModalLayout/components/ConfirmModal";
import { useUpdateTicketStatus } from "../../../hooks/useUpdateTicketStatus";
import { useAssignTicket } from "../../../hooks/useAssignTicket";
import { AssignIcon, StatusIcon } from "../../../layout/Components/icons";
import { isPermit } from "../../../utils/permissionCheck";

dayjs.extend(duration);
dayjs.extend(utc);
interface LeftSectionProps {
  currentPage?: string;
  ticketData?: any;
  ticketType: "None" | "Primary" | "Merged";
  onSwitchToPrimary?: () => void;
  refetchTickets: () => void;
}
interface Ticket {
  id?: number;
  pikitup_ticket_id?: number;
  service_ticket_no?: string;
  service_short_description?: string;
  service_long_description?: string;
  additional_details?: string;
  service_id?: number;
  service_type?: number;
  service_address_info?: string;
  ticket_owner_name?: string;
  customer_reference_no?: string;
  customer_contact_number?: string;
  email?: string;
  files?: { pikitup_ticket_image_id: number; filepath: string }[];
  status_flg?: number;
  admin_internal_status?: number;
}
interface Section {
  title: string;
  items: { label: string; value: string }[];
}

// interface Comment {
//   author: string;
//   date: string;
//   content: string;
//   refetchTickets: () => void;
// }

type TicketStatus =
  | "Resolved"
  | "Completed"
  | "Ongoing"
  | "Closed"
  | "Unassigned"
  | "Pending";

const LeftSection: React.FC<LeftSectionProps> = ({
  ticketType,
  ticketData,
  refetchTickets,
}) => {
  const navigate = useNavigate();
  const [assignConfirmOpen, setAssignConfirmOpen] = useState(false);
  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [, setSelectedRowKeys] = useState<any[]>([]);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openParkedModal, setOpenParkedModal] = useState(false);
  const [, setSelectedTicketId] = useState<number | null>(null);

  const storedUserRaw = localStorage.getItem("Data");
  let storedUser: any = {};
  try {
    storedUser = storedUserRaw ? JSON.parse(storedUserRaw) : {};
  } catch (e) {
    storedUser = {};
  }
  // const handleRejectClick = (ticketId: number) => {
  //   setSelectedTicketId(ticketId);
  //   setOpenRejectModal(true);
  // };

  // const handleParkedClick = (ticketId: number) => {
  //   setSelectedTicketId(ticketId);
  //   setOpenParkedModal(true);
  // };

  const { data: callTypes } = useCallTypes();

  const CALL_TYPES = [
    {
      service_id: 30016,
      call_type: "Street cleaning",
      service_desc: "Street not cleaned",
    },
    {
      service_id: 30019,
      call_type: "Missed collection",
      service_desc: "Collections not picked up",
    },
    {
      service_id: 30020,
      call_type: "Property damaged(pickitup) (domestic)",
      service_desc: "Pikitup damage to property (domestic)",
    },
    {
      service_id: 30021,
      call_type: "Illegal dumping",
      service_desc: "Pikitup illegal dumping",
    },
    {
      service_id: 30006,
      call_type: "Dead animal removal",
      service_desc: "Pikitup dead animals removal",
    },
  ];

  const callTypeValue =
    CALL_TYPES.find((ct) => ct.service_id === ticketData?.service_id)
      ?.call_type || "-";
  const breadcrumbItems = [
    {
      title: (
        <span
          onClick={() => navigate("/tickets")}
          className="breadcrumb-first flex gap-1"
        >
          <TicketsGrayIcon /> Tickets
        </span>
      ),
    },
    {
      title: (
        <span className="breadcrumb-second flex gap-1">
          <TicketsDetailIcon />{" "}
          {ticketData?.service_short_description || "Ticket Details"}
        </span>
      ),
    },
  ];
  const EXCLUDED_STATUSES = ["Rejected", "Closed", "Resolved"];

  const memberType = storedUser?.data?.member_type ?? storedUser?.membertype;

  const isMemberType3 = Number(memberType) === 3;
  const ActionMenu = (record: Ticket) => {
    const items: any[] = [];

    // Assign Ticket: show only if status is 1
    if (Number(record.status_flg) === 1 && isPermit(2, "assign")) {
      items.push({
        key: "assign",
        label: (
          <span className="flex justify-start items-center">
            <span style={{ marginRight: 8 }}>
              <AssignIcon />
            </span>
            Assign Ticket
          </span>
        ),
        onClick: () => {
          setSelectedRowKeys([record.id]);
          setAssignConfirmOpen(true);
        },
      });
    }

    // ✅ Change Status: show only if NOT in excluded statuses
    const currentStatusLabel = STATUS_MAP[record.status_flg?.toString()] || "";
    if (
      !EXCLUDED_STATUSES.includes(currentStatusLabel) &&
      isPermit(2, "edit")
    ) {
      items.push({
        key: "reject",
        label: (
          <span className="flex justify-start items-center text-red-600">
            <span style={{ marginRight: 8 }}>
              <StatusIcon />
            </span>
            Reject
          </span>
        ),
        onClick: () => {
          setSelectedTicketId(record.id);
          setOpenRejectModal(true);
        },
      });

      {
        !isMemberType3 &&
          isPermit(2, "edit") &&
          items.push({
            key: "parked",
            label: (
              <span className="flex justify-start items-center text-yellow-600">
                <span style={{ marginRight: 8 }}>
                  <StatusIcon />
                </span>
                Parked
              </span>
            ),
            onClick: () => {
              setSelectedTicketId(record.id);
              setOpenParkedModal(true);
            },
          });
      }
    }

    return { items };
  };

  const { mutate: updateTicketStatusMutate, isPending: isUpdating } =
    useUpdateTicketStatus();
  const { mutate: assignTicketMutate, isPending: isAssigning } =
    useAssignTicket();
  const sections: Section[] = [
    {
      title: "Information",
      items: [
        {
          label: "Ticket type",
          value:
            ticketData?.service_type === 2 ? "Incident" : "Service Request",
        },
        { label: "Call type", value: callTypeValue },
        { label: "Created on", value: ticketData?.created_date || "-" },
        { label: "Location", value: ticketData?.service_address_info || "-" },
        { label: "Owned by", value: ticketData?.ticket_owner_name || "-" },
        { label: "Assignee name", value: ticketData?.assignee_name || "-" },

        {
          label: "Unit Group",
          value: ticketData?.unit_group_name?.toString() || "-",
        },
      ],
    },
    {
      title: "Customer details",
      items: [
        {
          label: "Name",
          value:
            `${ticketData?.customer_first_name ?? ""} ${
              ticketData?.customer_surname ?? ""
            }`.trim() || "-",
        },
        {
          label: "Reference number",
          value: ticketData?.customer_reference_no || "-",
        },
        { label: "Address", value: ticketData?.service_address_info || "-" },
        {
          label: "Contact number",
          value: ticketData?.customer_contact_number || "-",
        },
        {
          label: "Email ID",
          value: ticketData?.email || "-",
        },
      ],
    },
  ];

  const descriptionData = {
    title: "Ticket Description",
    description: ticketData?.service_long_description || "-",
    additionalTitle: "Additional details:",
    additionalDescription: ticketData?.additional_details || "-",
  };

  // const statusClassMap: Record<TicketStatus, string> = {
  //   Resolved: "ant-tag-green",
  //   Completed: "ant-tag-cyan",
  //   Ongoing: "ant-tag-ongoing ",
  //   Closed: "ant-tag-red",
  //   Unassigned: "ant-tag-volcano",
  //   Pending: "ant-tag-orange",
  // };

  const STATUS_MAP: Record<string, string> = {
    "1": "New",
    "28": "Not Initiated",
    "10": "Initiated",
    "31": "Parked",
    "23": "Rejected",
    "6": "Resolved",
    "3": "Closed",
  };

  const status = ticketData?.status_flg?.toString() || "1"; // derive safely
  const label = STATUS_MAP[status] || "Unassigned";
  const statusClass = label.toLowerCase().replace(/\s+/g, "-");

  // const ticketStatus: TicketStatus = "Ongoing";
  // const shouldShowComments = ticketType !== "Merged";

  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const showUnassignedTimer =
    (ticketData.status_flg === 28 ||
      ticketData.status_flg === 10 ||
      ticketData.status_flg === 1) &&
    ticketData.created_date;

  const showUnassignedTimerResponse =
    (ticketData.status_flg === 28 || ticketData.status_flg === 1) &&
    ticketData.created_date;

  const formatCountdown = (targetTime: string) => {
    const now = dayjs();
    const escalationTime = dayjs(targetTime, "DD-MM-YYYY HH:mm:ss");

    // Calculate difference in seconds
    const diff = escalationTime.diff(now, "second");
    const dur = dayjs.duration(diff, "seconds");

    // ✅ Use total hours across days (not just within 24h)
    const hours = Math.floor(dur.asHours());
    const minutes = dur.minutes();
    const seconds = dur.seconds();

    // Format properly
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  // Response SLA
  const getUnassignedStatusResponse = () => {
    const { response_sla_escalation_time, response_sla_overdue } =
      ticketData || {};

    if (!response_sla_escalation_time) return null;

    const escalationTime = dayjs(
      response_sla_escalation_time,
      "DD-MM-YYYY HH:mm:ss"
    );
    const countdown = formatCountdown(response_sla_escalation_time);

    if (response_sla_overdue || dayjs().isAfter(escalationTime)) {
      return (
        <div className="sla_container">
          Response: <span className="breached">Breached</span>
        </div>
      );
    }

    return (
      <div className="sla_container">
        Response: <span className="timer">{countdown}</span>
      </div>
    );
  };

  // Resolution SLA
  const getUnassignedStatusResolution = () => {
    const { resolution_sla_escalation_time, resolution_sla_overdue } =
      ticketData || {};

    if (!resolution_sla_escalation_time) return null;

    const escalationTime = dayjs(
      resolution_sla_escalation_time,
      "DD-MM-YYYY HH:mm:ss"
    );
    const countdown = formatCountdown(resolution_sla_escalation_time);

    if (resolution_sla_overdue || dayjs().isAfter(escalationTime)) {
      return (
        <div className="sla_container">
          Resolution: <span className="breached">Breached</span>
        </div>
      );
    }

    return (
      <div className="sla_container">
        Resolution: <span className="timer">{countdown}</span>
      </div>
    );
  };

  return (
    <div className="left-details-frame">
      <div className="header-wrapper flex flex-col gap-4">
        <Breadcrumb items={breadcrumbItems} />
        <div className="ticket-heading-wrapper flex gap-3 items-baseline">
          <h3 className="heading">{ticketData.service_short_description}</h3>

          {ticketType !== "None" && (
            <div className="ticket-type flex items-center">
              {ticketType === "Merged" && (
                <span className="ticket-type-icon merged-ticket-wrap">
                  <MergedTicketIcon />
                </span>
              )}
              {/* {ticketType === "Primary" && (
                <span className="ticket-type-icon primary-ticket-wrap">
                  <PrimaryTicketIcon />
                </span>
              )} */}
            </div>
          )}

          <div className="tag-wrapper flex gap-3 items-center">
            <TagComp className="ant-tag-ticket">
              {ticketData.service_ticket_no}
            </TagComp>
            <div className="tag-wrapper flex gap-3 items-center">
              <span className={`status-pill status-${statusClass}`}>
                {label}
              </span>
              {/* {showUnassignedTimer && (
                <div className="unassigned-timer">{getUnassignedStatus()}</div>
              )} */}
            </div>
          </div>

          <div className="flex  gap-1 mt-2">
            {showUnassignedTimerResponse && getUnassignedStatusResponse()}
            {showUnassignedTimer && getUnassignedStatusResolution()}
          </div>

          {ActionMenu(ticketData).items.length > 0 && isPermit(2, "edit") && (
            <div className="ml-auto">
              <Dropdown
                menu={{ items: ActionMenu(ticketData).items }}
                trigger={["click"]}
              >
                <MoreOutlined
                  style={{
                    fontSize: "22px",
                    cursor: "pointer",
                    minWidth: "20px",
                  }}
                />
              </Dropdown>
            </div>
          )}
        </div>
        <div className="details-wrapper flex flex-col gap-6 mt-6">
          <div className="ticket-description-card mt-4">
            <h4 className="details-card-heading mb-2">
              {descriptionData.title}
            </h4>
            <p className="description mb-3">{descriptionData.description}</p>
            <span className="additional-heading mb-1">
              {descriptionData.additionalTitle}
            </span>
            <p className="description">
              {descriptionData.additionalDescription}
            </p>
          </div>

          {sections.map((section, index) => (
            <div
              key={index}
              className="section-card bg-gray-50 p-4 rounded-md shadow"
            >
              <h4 className="details-card-heading mb-3">{section.title}</h4>
              <div className="grid grid-cols-2 gap-4">
                {section.items.map((item, idx) => (
                  <div key={idx} className="flex flex-col">
                    <span className="text-sm text-gray-500">{item.label}</span>
                    <span className="font-medium">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        {ticketData?.files?.length > 0 && (
          <div className="attachments-wrapper mt-6">
            <span className="attachments-title">Attachments</span>

            <Image.PreviewGroup
              items={ticketData.files.map((file: { filepath: any }) => ({
                src: file.filepath,
              }))}
            >
              <div className="attachments-list flex gap-3 mt-3">
                {ticketData.files.slice(0, 4).map(
                  (
                    file: {
                      pikitup_ticket_image_id: React.Key | null | undefined;
                      filepath: string | undefined;
                    },
                    idx: number
                  ) => (
                    <div
                      key={file.pikitup_ticket_image_id}
                      className={`attachment-item ${
                        idx === 3 && ticketData.files.length > 4
                          ? "has-overlay"
                          : ""
                      }`}
                    >
                      <Image
                        src={file.filepath}
                        width={184}
                        height={178}
                        className="attachment-img"
                        rootClassName="attachment-image-wrapper"
                      />

                      {idx === 3 && ticketData.files.length > 4 && (
                        <div className="attachment-overlay">
                          <span className="overlay-text">
                            +{ticketData.files.length - 4}
                          </span>
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            </Image.PreviewGroup>
          </div>
        )}

        <ChangeStatusModal
          loading={isUpdating}
          mode={
            openRejectModal ? "rejected" : openParkedModal ? "parked" : "parked"
          }
          open={openRejectModal || openParkedModal || changeStatusModalOpen}
          onClose={() => {
            setChangeStatusModalOpen(false);
            setOpenRejectModal(false);
            setOpenParkedModal(false);
          }}
          onConfirm={({ status, description }) => {
            updateTicketStatusMutate(
              {
                service_ticket_no: ticketData.service_ticket_no,
                status: Number(status),
                comments: description || "",
              },
              {
                onSuccess: (res) => {
                  message.success(
                    res.message || "Ticket status updated successfully"
                  );
                  setChangeStatusModalOpen(false);
                  setOpenRejectModal(false);
                  setOpenParkedModal(false);
                  refetchTickets();
                },
                onError: () => {
                  message.error("Failed to update ticket status");
                },
              }
            );
          }}
        />
        {assignConfirmOpen && (
          <ConfirmModal
            open={assignConfirmOpen}
            loading={isAssigning}
            title="Assign ticket"
            message={`You are about to assign selected ticket.`}
            confirmText="Assign"
            onClose={() => setAssignConfirmOpen(false)}
            onConfirm={() => {
              assignTicketMutate(
                {
                  pikitup_ticket_ids: [Number(ticketData.pikitup_ticket_id)],
                },
                {
                  onSuccess: (res) => {
                    message.success(
                      res.message || "Tickets assigned successfully"
                    );
                    setAssignConfirmOpen(false);
                    setSelectedRowKeys([]);
                    refetchTickets();
                  },
                  onError: (err: any) => {
                    message.error(
                      err?.response?.data?.message ||
                        "Failed to assign tickets. Please try again."
                    );
                  },
                }
              );
            }}
          />
        )}
        {/* {shouldShowComments && (
          <div className="comments-section mt-6">
            <h4 className="details-card-heading mb-2">Comments</h4>

            {/* <div className="add-comment mb-4">
                     comment section
                    </div> */}
        {/* <span className="secondary-heading">Previous comments</span>
            <div className="previous-comments flex flex-col gap-4">
              {comments.map((comment, idx) => (
                <div key={idx} className="comment-card flex flex-col">
                  <div className="name-wrapper flex items-center gap-2">
                    <span className="commented-user ">{comment.author}</span>
                    <span className="date">{comment.date}</span>
                  </div>
                  <p className="comment">{comment.content}</p>
                </div>
              ))}
            </div>
          </div> */}
        {/* )} } */}
        {/* Reject Modal */}
      </div>
    </div>
  );
};

export default LeftSection;
function setTick() {
  throw new Error("Function not implemented.");
}
